import { http, Result } from "@fider/services/http"

export type SuggestionKind = "post" | "comment"

export interface ContentSuggestion {
  title: string
  text: string
  changed: boolean
  note: string
}

// Gọi AI chuẩn hóa chính tả, dấu tiếng Việt và ngữ pháp (tùy biến KHCN)
export const suggestContent = async (kind: SuggestionKind, title: string | undefined, text: string): Promise<Result<ContentSuggestion>> => {
  return await http.post<ContentSuggestion>("/api/v1/ai/suggest", { kind, title: title ?? "", text })
}

// Không có bước chờ duyệt tay: AI (hoặc bộ lọc nội bộ) chỉ trả về ok hoặc reject
export type ContentVerdict = "ok" | "reject"

export interface ContentCheck {
  verdict: ContentVerdict
  field: "title" | "content"
  reason: string
  categories: string[]
  source: "local" | "ai"
  aiAvailable: boolean
}

export interface ContentCheckContext {
  // Bài đăng: slug hạng mục người đăng chọn, để AI đối chiếu tiêu chí
  category?: string
  // Bình luận: số bài đang thảo luận, để AI biết bối cảnh
  postNumber?: number
}

// Kiểm tra nội dung trước khi gửi: bộ lọc nội bộ rồi AI kiểm duyệt theo tiêu chí hạng mục (tùy biến KHCN)
export const checkContent = async (
  kind: SuggestionKind,
  title: string | undefined,
  text: string,
  context: ContentCheckContext = {}
): Promise<Result<ContentCheck>> => {
  return await http.post<ContentCheck>("/api/v1/content/check", {
    kind,
    title: title ?? "",
    text,
    category: context.category ?? "",
    postNumber: context.postNumber ?? 0,
  })
}
